/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "amplifyIdentityBrokerApi",
            "endpoint": "https://faiwrtwhnh.execute-api.eu-west-1.amazonaws.com/ibrnd",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:450a8a97-d6c0-4118-b4ae-6462af1109e5",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_54u6HDLn8",
    "aws_user_pools_web_client_id": "7h3iseinrhog9kkf2t0qevp1b4",
    "oauth": {
        "domain": "wave-identity-broker-ibrnd.auth.eu-west-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://d33v25xlsgqgan.cloudfront.net",
        "redirectSignOut": "https://d33v25xlsgqgan.cloudfront.net/logout",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "broker--hostingbucket-ibrnd",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d33v25xlsgqgan.cloudfront.net",
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "amplifyIdentityBrokerClients-ibrnd",
            "region": "eu-west-1"
        },
        {
            "tableName": "amplifyIdentityBrokerCodes-ibrnd",
            "region": "eu-west-1"
        },
        {
            "tableName": "amplifyIdentityBrokerInstance-ibrnd",
            "region": "eu-west-1"
        },
        {
            "tableName": "amplifyIdentityBrokerRegistrationCodes-ibrnd",
            "region": "eu-west-1"
        },
        {
            "tableName": "amplifyIdentityBrokerUser-ibrnd",
            "region": "eu-west-1"
        },
        {
            "tableName": "amplifyIdentityBrokerUserInstance-ibrnd",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
